module.exports = __webpack_public_path__ + "static/media/feiyong@4x..fe392153.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/feiyong@4x..png
// module id = 1754
// module chunks = 0 1